import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-home-page-blog',
  standalone: true,
  imports: [RouterLink, CommonModule],
  templateUrl: './home-page-blog.component.html',
  styleUrl: './home-page-blog.component.scss',
})
export class HomePageBlogComponent {}
